module.exports = {
	"site.title": "La Biblia en sus Tradiciones",
	"Old Testament": "Antiguo Testamento",
	"New Testament": "Nuevo Testamento",
	"footer": {
		"project.of": "Un proyecto de  Programa de Investigación La Biblia en su Tradiciones AISBL",
		"ebaf.link": "Dirigido por la <a href=\"http://www.ebaf.edu/\">École Biblique et Archéologique Française</a> de Jérusalem",
		"donation.link": "Para ayudarnos, <a href=\"http://scroll.bibletraditions.org/register\">haga clic aquí</a>",
		"copyright": "© 2008–2023 BEST AISBL | École Biblique. Todos los derechos reservados. Patente pendiente."
	},
	"frontdoor": {
		"about.h": "De qué se trata este sitio",
		"about": "La Biblia en sus Tradiciones es un proyecto de la École Biblique et Archéologique Française de Jérusalem, los creadores de la Biblia de Jerusalén.",
		"goal.h": "El objetivo de este proyecto",
		"goal": "Se trata de crear una serie de notas para toda la Biblia, lo más amplias y útiles posibles, con información de interés tanto para estudiosos de la Biblia como lectores ocasionales.",
		"features.h": "Características propias",
		"features": "La Biblia en sus Tradiciones presentará las diferencias significativas entre las diferentes versiones de la Biblia en el texto mismo más que en las notas a pie de página. Además, el texto estará acompañado de amplias notas distribuidas según diferentes tópicos, como vocabulario, ambiente social y cultural, tradición judía y cristiana, entre otros.",
		"sample": "Ver este ejemplo",
		"demonstration.volume": "Consultar nuestro volumen de demostración",
		"visit.the.blog": "Seguir en directo",
		"visit.the.scroll": "Visitar la interfaz de consultación",
		"contrib.h": "Para potenciales colaboradores",
		"contrib": "Estamos buscando activamente colaboraciones de especialistas para nuestro proyecto. Si a usted le gustaría proponer un ejemplo de traducción  de un pasaje con su serie de notas para que sea considerado por nuestros editores,por favor,contáctenos.",
		"lagrange": "P. M.-J. Lagrange, fundador de la École Bilique"
	},
	"legal.terms": "Aviso Legal",
	"browser.too.old": "Este sitio no funcionará correctamente con el navegador actual. Actualícelo a Internet Explorer 11 o Edge, o bien descargue Chrome, Firefox, Opera o Safari.",
	"content.type": {
		"biblio.ref": "referencia bibliográfica",
		"Biblio.Ref": "Referencia bibliográfica",
		"biblio.refs": "referencias bibliográficas",
		"Biblio.Refs": "Referencias bibliográficas",
		"marg.ref": "referencia marginal",
		"Marg.Ref": "Referencia marginal",
		"marg.refs": "referencias marginales",
		"Marg.Refs": "Referencias marginales",
		"note": "nota",
		"Note": "Nota",
		"notes": "notas",
		"Notes": "Notas",
		"synth.note": "nota de síntesis",
		"Synth.Note": "Nota de síntesis",
		"synth.notes": "notas de síntesis",
		"Synth.Notes": "Notas de síntesis",
		"verse": "versículo",
		"Verse": "Versículo",
		"verses": "versículos",
		"Verses": "Versículos"
	},
	"bibliography": "bibliografía",
	"@Demonstration_Volume@": "Volumen de demostración",
	"bible.passage": {
		"label.noscript": "Ir a un pasaje bíblico:",
		"goto": "Ir a %s",
		"search": "Buscar “%s”"
	},
	"PDF": "PDF",
	"ODT": "ODT (LibreOffice/OpenOffice)",
	"@View_as@": "Ver como",
	"@New...@": "Nueva...",
	"@edit_marg_ref@": "Editar la referencia marginal",
	"@new_marg_ref@": "Referencia marginal",
	"@new_bib_ref@": "Referencia bibliográfica",
	"@edit_note@": "Editar nota",
	"@edit_reference@": "Editar referencia",
	"@new_note@": "Nota",
	"@edit_synth_note@": "Editar nota de síntesis",
	"@new_synth_note@": "Nota de síntesis",
	"@Edit_External_Link@": "Editar hipervínculo externo",
	"@Insert_Image@": "Insertar imagen",
	"@Insert_Media@": "Insertar materiales",
	"@Select@": "Selección",
	"@Upload@": "Subir",
	"@Select_file@": "Seleccione archivo",
	"@Select_folder@": "Seleccione carpeta",
	"@Upload_file@": "Archivo",
	"@Filter@": "Filtrar",
	"@Loading...@": "Cargando...",
	"@New_Revision@": "Nueva revisión",
	"@edit_scope@": "Extendido",
	"@edit_lemma@": "Lema",
	"@edit_link@": "Vínculo",
	"@edit_title@": "Título",
	"@edit_text@": "Texto",
	"@edit_caption@": "Leyenda",
	"@edit_comment@": "Comentario",
	"@edit_abbrev@": "Abreviación",
	"@edit_zotero_id@": "ID en Zotero",
	"@edit_parallel@": "¿Paralelo?",
	"@Cut@": "Cortar",
	"@Copy@": "Copiar",
	"@Paste@": "Pegar",
	"@URL@": "URL",
	"homedir": "Inicio",
	"editorial.info": {
		"revision.and.content.id": " %s (%s rev. %s)",
		"rev.n.and.author": "rev. %s (%s) de %s",
		"id.and.author": "%s (%s rev. %s) de %s"
	},
	"@login@": "entrar",
	"@Login@": "Entrar",
	"@invalid_login@": "Nombre o contraseña inválidos",
	"@logout@": "salir",
	"@password@": "Contraseña",
	"session": {
		"about.to.expire": "La sesión está a punto de caducar. Pulse “Continuar” para permanecer conectado."
	},
	"continue": "Continuar",
	"admin": {
		"menu": "Admin",
		"users": "Administrar usuarios",
		"change.password": "Cambio de contraseña",
		"permissions": "Autorizaciones",
		"teams": "Equipos",
		"cache": "Cache"
	},
	"pericopes": {
		"total": "%s pericopas"
	},
	"pericope": {
		"new": "Nueva perícopa"
	},
	"users": {
		"type.name.email.or.id": "Escriba un nombre, una dirección electrónica o una identificación",
		"total": "%s usuarios",
		"all": "Todos los usuarios",
		"admins": "Administradores",
		"contributors": "Colaboradores",
		"scribes": "Escribanos"
	},
	"user": {
		"new": "Nuevo usuario",
		"edit": "Editar %s",
		"verify.delete": "¿Eliminar este usuario?",
		"name": "Nombre de usuario",
		"firstname": "Nombre",
		"lastname": "Apellido",
		"email": "Correo electrónico",
		"roles": "Tareas",
		"lang": "Language",
		"is.active": "¿Activo?",
		"is.approved": "¿Aceptado?",
		"is.deleted": "¿Eliminado?",
		"is.admin": "¿Administrador?",
		"is.contributor": "¿Colaborador?",
		"is.scribe": "¿Escribano?",
		"change.password": "Cambio de contraseña",
		"password.again": "Ingresar nuevamente la contraseña",
		"created": "Usuario creado.",
		"saved": "Usuarios guardado.",
		"permissions": {
			"heading": "Autorizaciones",
			"saved": "Autorizaciones guardadas."
		},
		"error": {
			"passwords.do.not.match": "Las contraseñas no coinciden.",
			"new.users.need.password": "Los nuevos usuarios deben tener una contraseña.",
			"email.must.be.unique": "Esta dirección electrónica ya ha sido registrada.",
			"user.needs.email": "Entre una dirección elctrónica, por favor."
		}
	},
	"teams": {
		"type.name.or.id": "Escriba un nombre o una identificación",
		"total": "%s equipos"
	},
	"team": {
		"new": "Nuevo equipo",
		"verify.delete": "¿Eliminar este equipo?",
		"edit": "Editar equipo “%s”",
		"name": "Nombre del equipo",
		"books": "Libros",
		"members": "Miembros",
		"leaders": "Responsables",
		"members.and.leaders": "Responsable y miembros del equipo",
		"available.users": "Usuarios disponible",
		"member.permissions": "Autorizaciones de miembros del equipo",
		"created": "Equipo creado.",
		"saved": "Equipo guardado.",
		"members.saved": "Miembros del equipo guardados."
	},
	"books": {
		"assigned": "Libros asignados",
		"available": "Libros disponibles"
	},
	"@Write@": "Escribir",
	"@None@": "Nada",
	"@all_types@": "Todos los tipos",
	"@not_approved_users_table_header@": "Hay %s usuarios esperando su aprobación",
	"@approve_user_sure@": "¿Aprovar este usuario?",
	"@admin@": "Administrador",
	"@Contributor@": "Colaborador",
	"@Scribe@": "Escribano",
	"@user@": "Usuario",
	"@team@": "Equipo",
	"@please_enter@": "Entre, por favor.",
	"@please_enter_valid_email@": "Entre una dirección electrónica válida, por favor.",
	"@register@": "Registrarse",
	"@forgot_password@": "¿Ha olvidado su Contraseña?",
	"@password_again@": "Escriba nuevamente la contraseña",
	"@verify_password@": "Verificque la contaseña",
	"@success_password_changed@": "Contraseña cambiada.",
	"@register_complete@": "Registración completada: Usted recibirá una notificación por correo electrónico cuando un administrador haya aprobado su cuenta.\"",
	"@search@": "Búsqueda",
	"@manage_team_users@": "Administración de usuarios del equipo “%s”",
	"@add_users_to_team@": "Agregar usuarios al equipo",
	"@select_team_leader@": "Elegir el responsable del equipo",
	"@Caches@": "Caches",
	"@empty@": "vaciar",
	"@Cache_emptied@": "El cache se ha vaciado",
	"message.join": "%s: %s",
	"form": {
		"required": "Obligatorio"
	},
	"@Error@": "Error",
	"@edit@": "editar",
	"@Edit@": "Editar",
	"@delete@": "eliminar",
	"@close@": "cerrar",
	"@edit_save@": "Guardar",
	"@change@": "cambiar",
	"@cancel@": "Anular",
	"@yes@": "si",
	"@no@": "no",
	"@Previous@": "Previo",
	"@Next@": "Siguiente &gt;",
	"@first@": "primero",
	"@last@": "último",
	"opens.in.new.tab": "se abre en una pestaña nueva",
	"Filter.verb": "Filtrar",
	"@Scope@": "Extendido",
	"@range@": "%s–%s",
	"@rows_total@": "%s filas",
	"@Download@": "Descargar",
	"@PaperFormat@": "Tamaño de papel",
	"@FontSize@": "Tamaño de la letra",
	"@PaperLetter@": "Carta",
	"all.traditions": "Todas las tradiciones textuales",
	"@verse_1untranslated@": "Algunos o todos los versículos que aparecen arriba todavía no han sido traducidos para este proyecto. En tales casos, se ha utilizado en su lugar un texto común de dominio público.",
	"@verse_2untranslated@": "Los versículos que como éste aparecen, provienen de la versión Reina Valera.",
	"editorial": {
		"pericopes": "Definir perícopas",
		"activity": "Actividad"
	},
	"only.errors": "Solo errores",
	"@book@": "Libro",
	"@select_book@": "Seleccionar libro",
	"@select_user@": "Seleccionar usuario",
	"@save_changes@": "Guardar cambios",
	"@please_select@": "Seleccione, por favor",
	"@home@": "página principal",
	"@send@": "Enviar",
	"@forgot_password_text@": "Por favor, escriba su dirección electrónica y su contraseña le será enviada.",
	"@email_not_exists@": "Dirección electrónica no registrada",
	"@forgot_password_letter_send@": "Una nueva contraseña le ha sido enviada",
	"@issues@": "Cuestiones",
	"@all_authors@": "Todos los autores",
	"@author@": "Autor",
	"@assigned_to@": "Asignado a",
	"@status@": "Estado",
	"@Type_Status_Assigned_to@": "Tipo: %s, Estado: %s, Asignado a: %s",
	"@Created@": "Creado: %s",
	"@editorial_info@": "Información editorial",
	"@Last_Modified@": "Ultima modificación: %s",
	"@approve@": "aprobar",
	"@Approve@": "Aprobar",
	"@publish@": "publicar",
	"@Publish@": "Publicar",
	"@history@": "historia",
	"@History@": "Historia",
	"@Full_History@": "Historia completa",
	"@Compare_Revisions@": "Comparar las revisiones",
	"@Show_editorial_information@": "Mostrar la información editorial",
	"@published@": "Publicado",
	"@PUBLISHED@": "PUBLICADO",
	"@approved@": "Aprobado",
	"@APPROVED@": "APROBADO",
	"@awaiting_approval@": "Esperando la aprobación",
	"@AWAITING_APPROVAL@": "ESPERANDO LA APROBACION",
	"@archived@": "Archivado",
	"@Audience@": "Destinatarios",
	"@Change_Audience@": "Cambiar",
	"@public@": "Público",
	"@general@": "Donantes",
	"@scholarly@": "Colaboradores",
	"@no_audience@": "sin público",
	"@ARCHIVED@": "ARCHIVADO",
	"@PUBLIC@": "PUBLICO",
	"@GENERAL@": "DONANTES",
	"@SCHOLARLY@": "COLABORADORES",
	"@NO_AUDIENCE@": "SIN DESTINATARIOS",
	"@show_all@": "Mostrar todo",
	"@type@": "Tipo",
	"@title@": "Título",
	"@date@": "Fecha",
	"@id@": "ID",
	"@issue_count@": "%s cuestiones",
	"@note_count@": "%s notas",
	"@you_are_not_approved@": "¡Usted no está aprobado!",
	"@you_are_not_activated@": "¡Usted no ha sido activado!",
	"@registered@": "Registrado",
	"@note@": "nota",
	"@Note@": "Nota",
	"@rev@": "rev. %d",
	"@by@": "de %s",
	"@Marg_ref_and_id@": "Referencia marginal %d",
	"@Marg_ref_rev_and_id@": "Referencia marginal %d rev. %d (%d)",
	"@Bib_ref_and_id@": "Referencia bibliográfica %d",
	"@Bib_ref_rev_and_id@": "Referencia bibliográfica %d rev. %d (%d)",
	"@Note_and_id@": "Nota %d",
	"@Note_rev_and_id@": "Nota %d rev. %d (%d)",
	"@Synth_note_and_id@": "Nota de síntesis %d",
	"@Synth_note_rev_and_id@": "Nota de síntesis %d rev. %d (%d)",
	"@Verse_and_id@": "%s %d",
	"@Verse_rev_and_id@": "%s %d rev. %d (%d)",
	"@Submit@": "Confirmar",
	"@Save_as_Draft@": "Guardar como borrador",
	"@rev_and_id@": "%d rev. %d (%d)",
	"@revision@": "Revisión",
	"@draft@": "Borrador",
	"@DRAFT@": "BORRADOR",
	"@approved_by@": "Aprobado por %s en %s",
	"@disapprove@": "Desaprobado",
	"@Original_Active_Revision@": "Revisión original activa: %s",
	"@Original_Revision@": "Revisión original: %s",
	"@Active_Revision@": "Revisión activa: %s",
	"@dismiss@": "Descartar",
	"@other_revisions_text@": "Esta nota tiene también otras revisiones no aprobadas.",
	"@count_issues_associated@": "Hay %s cuestiones vinculadas a este cambio.",
	"@text@": "Texto",
	"@assigned_by@": "Asignado por",
	"@assign_to@": "Asignado a",
	"@New_Issue@": "Nueva cuestión",
	"@New_Comment@": "Agregar un nuevo comentario",
	"@new@": "Nuevo",
	"@feedback@": "Observaciones",
	"@closed@": "Cerrado",
	"@open@": "Abierto",
	"@acknowledged@": "Agradecimiento",
	"@message@": "Mensaje",
	"@issue_title@": "Titulo de la cuestión",
	"@ref@": "Ref",
	"@created@": "Creado",
	"@Rev@": "Rev",
	"@delete_issue_confirm@": "¿Está seguro que quiere eliminar esta cuestión?",
	"@Choose_Synth_Note@": "Elegir una nota de síntesis",
	"@Link_Text@": "Texto de enlace",
	"@Choose@": "Elegir",
	"@selection@": "Selección",
	"synthetic.note": {
		"not.found": {
			"title": "No se encuentra la nota de síntesis",
			"text": "<p>No se encuentra la nota de síntesis. Esto significa que probablemente aún no ha sido publicado.</p>"
		}
	},
	"bibliographic.reference": {
		"not.found": {
			"title": "No se encuentra la referencia bibliográfica",
			"text": "<p>No se encuentra la referencia bibliográfica. Esto significa que probablemente aún no ha sido publicado.</p>"
		}
	},
	"reference": {
		"not.found": "No se encuentra la referencia"
	},
	"@error.verify@": "Ha ocurrido un error: %s. %s Por favor verifique lo que ha escrito.",
	"@error.marg_ref_not_saved@": "No se guardaron las referencias marginales.",
	"@error.bib_ref_not_saved@": "No se guardaron las referencias bibliográficas.",
	"@error.note_not_saved@": "La nota no fue guardada.",
	"@error.synth_note_not_saved@": "La nota de síntesis no fue guardada.",
	"@error.verse_not_saved@": "No se guardó el versículo.",
	"Failed to parse": "Error al analizar",
	"No context for parsing": "Sin contexto para el análisis",
	"Unknown book": "No reconocido el libro",
	"Unknown delimiter": "Indicador de extensión desconocido",
	"Invalid chapter": "Capítulo inválido",
	"Verse fragment or following verses after chapter": "Capítulo seguido de un fragmento o versículos siguientes",
	"No chapter or verse at the end of a verse range": "Falta indicar capítulo o versículo después del guión",
	"Found \"f\" or \"ff\" at the end of a verse range": "Se encontró una ‘s’ o ‘ss’ al final de una serie de versículos definidos",
	"Range followed by another range": "Serie de versículos seguida de otra serie"
};